module.exports = __webpack_public_path__ + "img/icono-cerrarModal.cc6c1024.svg";